import { render } from "./UndoRedo.vue?vue&type=template&id=f016f140&scoped=true"
import script from "./UndoRedo.vue?vue&type=script&lang=js"
export * from "./UndoRedo.vue?vue&type=script&lang=js"

import "./UndoRedo.vue?vue&type=style&index=0&id=f016f140&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f016f140"]])

export default __exports__